import axios from 'axios'
import { Message } from 'element-ui'
import { env } from '../dataJson/custom'

// let userInfo = getUserInfo
const service = axios.create({
    baseURL: process.env.ERP_API,
    // timeout: 15000
    withCredentials: true // 允许携带cookie
})

function requestMethods(config){
  let url = config.url;
  config.url = url.replace(/^(.*?)\/.*?\//, `$1/readermain/`)
  // config.url = url.replace(/^(.*?)\/.*?\//, `$1/ttreader/`)
  return config;
}
service.interceptors.request.use(config => {
  config = requestMethods(config);
    if(localStorage.getItem('token') ){
        config.headers.token =  localStorage.getItem('token'); 
        config.headers.orgId =  localStorage.getItem('orgId');  
        config.headers.userId =  localStorage.getItem('userId');
        config.headers.sign =  localStorage.getItem('sign');
        config.headers.deviceType = 1;
    }
  return config;
}, error => {
  console.log(error)
  Promise.reject(error)
})

service.interceptors.response.use(response => {
    if (response.data.code === '200' || response.data.code === '201' || response.data.code == "TTDH00") {
        return response.data
    } else {
        Message({
          message: response.data.errorMsg,
          type: 'error',
          duration: 5000
        });
    }

    if(response.data.code === "TTST17" || response.data.code === "TTST05" || response.data.code === "TTST01" || response.data.code === "TTST00" || response.data.code === "TTST16" || response.data.code === "TTST15" || response.data.code === "TTST19") {
        // let aaa = location.href.split("/")
        // if(aaa[5]){
            // let href = '/' +  aaa[4] + '/' + aaa[5];
            if(window.location.hash != '#/' && !window.location.hash.includes('authVerify')){
              localStorage.setItem("remindLink", window.location.hash);
            }
            setTimeout(() => {
                location.replace('/');
            }, 1000);
        // }
        localStorage.removeItem("userInfo");
        localStorage.removeItem("orgId");
        localStorage.removeItem("userId");
        localStorage.removeItem("token");
        localStorage.removeItem("sign");
        localStorage.removeItem("account");
        localStorage.removeItem("demoSignal");
        localStorage.removeItem("authKey");
        return;
    }
    // if(response.data.code === "TTST19") {
    //     this.$router.push({path:"/home/404"})
    // }
}, error => {
  Message({
    message: error.errorMsg,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/sealFilter/requestCtxs.js